<template>
  <el-dialog
    :title="`${retailer._id ? 'Edit' : 'New'} Retailer`" :model-value="flagVisible" width="30%"
    :before-close="handleClose"
  >
    <el-form ref="form" :model="retailer" label-position="top" size="small">
      <el-form-item>
        <span>Name:</span>
        <el-input v-model="retailer.name" placeholder="Name" style="width: 80%;margin-left: 2%;"></el-input>
      </el-form-item>
      <el-form-item>
        <span>Status:</span>
        <el-select v-model="status" filterable style="width: 80%;margin-left: 2%;" placeholder="Select Status">
          <el-option key="1" label="Active" :value="1"></el-option>
          <el-option key="2" label="Inactive" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <div class="imageGroup">
          <div>Image:</div>
          <div class="image-item" >
            <el-upload
                :show-file-list="false" action="" :http-request="uploadImage"
                :data="imageKey"
            >
             <div class="image-operation" v-if="image_url">
              <div class="uploader-preview">
                <el-image v-loading="flagLoading.photoUpload" class="preview-img" :src="image_url" fit="contain" />
              </div>
              <el-button type="danger" class="el-btn-red" icon="el-icon-delete" size="small" @click.stop="deletePhoto()" :loading="flagLoading.photoDelete">Delete</el-button>
             </div>
            <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
          </div>
        </div>
        <span class="image-tip" style="margin-left: 10%;">(Image will be directly updated or deleted)</span>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="small" @click="handleClose">CANCEL</el-button>
        <el-button size="small" class="el-btn-blue" :loading="flagLoading.save" @click="handleSave">SAVE</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { reactive } from 'vue'
import moment from 'moment'
export default {
  props: {
    flagVisible: Boolean,
    actionItem: Object
  },
  emits: ['closeModal', 'reloadData'],
  data: function () {
    const flagLoading = reactive({
      save: false,
      photoUpload: false,
      photoDelete: false
    })
    return {
      uploadFileLists: [],
      timestamp: '',
      retailer: {},
      name: '',
      status: '',
      image_url: '',
      imageKey: {},
      retailer_image: {},
      flagLoading
    }
  },
  created: function () {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        this.name = ''
        this.status = ''
        this.image_url = ''
        this.imageKey = {}
        this.retailer_image = {}
        if (val._id) {
          this.retailer = { ...val }
          this.status = (this.retailer.status === '1') ? 'Active' : 'Inactive'
          this.image_url = this.retailer.retailer_image.url
        }
      },
      deep: true
    }
  },
  methods: {
    handleClose: function () {
      this.retailer = {}
      this.$emit('closeModal')
    },
    handleSave: function () {
      if (!this.retailer._id) {
        this.createRetailer()
      }
      if (this.retailer._id) {
        this.saveRetailer()
      }
    },
    uploadImage: async function (params) {
      const { file } = params
      const extention = file.name.split('.').pop()
      this.timestamp = new Date().getTime()
      const key = 'images/origin/retailers/' + this.retailer._id + '_' + this.timestamp + '.' + extention
      const uploadParams = {
        key: key
      }
      const url = '/api/v1/admin/aws/presigned'
      const that = this
      this.flagLoading.photoUpload = true
      this.$service.post(url, uploadParams).then(function (res) {
        if (res.code === 200) {
          const presignedUrl = res.data.presigned_url
          const objUrl = new URL(presignedUrl)
          const imageUrl = `${objUrl.origin}${objUrl.pathname}`
          const xhr = new XMLHttpRequest()
          xhr.open('PUT', presignedUrl, true)
          xhr.setRequestHeader('Content-Type', file.type)
          xhr.setRequestHeader('x-amz-acl', 'public-read')
          xhr.onload = () => {
            if (xhr.status === 200) {
              that.flagLoading.photoUpload = false
              that.image_url = imageUrl
            }
          }
          xhr.onerror = () => {
            console.error('upload to s3 | error')
            that.$message({ type: 'error', message: 'Upload error' })
          }
          // xhr.upload.onprogress = (event) => {
          //   console.log('inprogress', event)
          //   if (event.lengthComputable) {
          //     const percent = Math.round((event.loaded / event.total) * 100)
          //     that.loadingPercent = percent
          //   }
          // }
          xhr.send(file)
        } else {
          console.error('uploadImage | presigned_url', res.msg)
          that.$message({ type: 'error', message: res.msg })
        }
      }).catch(function (err) {
        console.error('uploadImage | presigned_url', err)
        that.$message({ type: 'error', message: err.msg })
      })
    },
    deletePhoto: function () {
      this.image_url = ''
    },
    saveRetailer: function () {
      this.flagLoading.save = true
      const url = `/api/v1/admin/retailers/${this.retailer._id}`
      const tz = moment().utcOffset()
      const that = this
      const body = {}
      body.name = this.retailer.name
      switch (this.status) {
        case 'Active':
        case 1:
          body.status = '1'
          break
        case 'Inactive':
        case 0:
          body.status = '0'
          break
        default:
          body.status = '0'
          break
      }
      body.retailer_image = !this.retailer_image ? this.retailer.retailer_image : {
        url: this.image_url,
        key: 'retailers/' + this.retailer._id + '/retailerImage',
        createdAt: moment(this.timestamp).utcOffset(tz).format('YYYY-MM-DD HH:mm:ss')
      }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Save retailer success' })
          that.handleClose()
          setTimeout(function () {
            that.retailer = {}
            that.$emit('reloadData')
          }, 100)
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('saveRetailer', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    beforeImageUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.success('The size of the uploaded picture cannot exceed 2MB!')
      }
      return isLt2M
    }
  }
}
</script>
<style scoped lang="scss">
.imageGroup {
  display: flex;
  .image-item {
    margin-left: 2%;
    display: flex;
    align-items: flex-end;
    .el-upload {
      border: 1px dashed #D9D9D9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      &:hover {
        border-color: #409EFF;
      }
      .uploader-icon {
        border: 1px solid #c0ccda;
        border-radius: 6px;
        font-size: 26px;
        color: #8C939D;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
      }
      .image-operation {
        display: flex;
        justify-content: flex-start;
        align-content: center;
        .uploader-preview {
          border: 1px solid #c0ccda;
          border-radius: 6px;
          width: 100px;
          height: 100px;
          padding: 10px;
          .preview-img {
            width: 80px;
            height: 80px;
          }
        }
        .el-btn-red {
          margin: 18%;
          height: 32px;
          padding: 9px 15px;
          font-size: 12px;
          border-radius: calc(var(--el-border-radius-base) - 1px);
        }
      }
    }
    .uploader-file-name {
      color: #ABABAB;
      padding: 0 0 10px 10px;
    }
  }
}
</style>
